import { createSlice } from "@reduxjs/toolkit";

import { RootState } from "@/redux";

import { CompanyBalance } from "../../pages/ManageCompanyBalance/schema/company-balance";

import { CompanyBalanceApi } from "./company-balance.api";

const initialState: CompanyBalance[] = [];

export const companyBalanceSlice = createSlice({
	name: "company-balance",
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addMatcher(
			CompanyBalanceApi.endpoints.getCompanyBalances.matchFulfilled,
			(_, { payload }) => payload ?? []
		);
		builder.addMatcher(
			CompanyBalanceApi.endpoints.createCompanyBalance.matchFulfilled,
			(state, { payload }) => {
				if (payload?.id) {
					return [...state, payload];
				}

				return state;
			}
		);
		builder.addMatcher(
			CompanyBalanceApi.endpoints.updateCompanyBalance.matchFulfilled,
			(state, { payload }) => {
				const index = state.findIndex((i) => i.id === payload.id);

				if (index !== -1) {
					state[index] = payload;
				}

				return state;
			}
		);
		builder.addMatcher(
			CompanyBalanceApi.endpoints.deleteCompanyBalance.matchFulfilled,
			(_, { payload }) => payload ?? []
		);
	},
});

export const companyBalanceReducer = companyBalanceSlice.reducer;
export const companyBalanceSelector = (state: RootState) => state[companyBalanceSlice.name];
